import React, { useState } from 'react'
import { href, useNavigate } from 'react-router-dom'
import apiClient from '../../utils/apiclient';
const Index = ({data}) => {
    console.log(data)
     const [search,Setsearch]=useState("")

    const navigate=useNavigate();
    const approveRestaurant=async(id)=>{
            try{
                const response = await apiClient.post ("/setAuthorized",
                        {"id":id}
                    );
                console.log(response)

                navigate(0)
            }
            catch (err) {
        console.error("Something went wrong",err);
      }
        }
        const filteredData = data.filter((el) => {
    if (search.trim() === "") {
      return true; 
    }
    return (
      el.name?.toLowerCase().includes(search.toLowerCase()) || 
      el.number?.toString().includes(search) ||
      el.email?.toLowerCase().includes(search.toLowerCase())
    );
  });
    const handlechange=(e)=>{
        const value=e.target.value;
        Setsearch(value);
        console.log(value)
    }
    return (
    <div className="w-full flex-1 flex flex-col min-h-0 mt-4">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-2 flex-shrink-0 gap-2 md:gap-0">
        <h2 className="text-lg md:text-xl font-bold text-gray-800">Unauthorized Riders</h2>
        <input 
          className="flex-shrink-0 w-full md:w-1/3 border-2 px-4 py-2 rounded-lg outline-none focus:border-blue-500" 
          placeholder="Search by name, number or email..." 
          onChange={handlechange}  
          value={search}
        />
      </div>

      <div className="w-full flex-1 overflow-auto pb-4 relative">
        <table className="min-w-max w-full bg-white shadow-md border-collapse">
          <thead className="bg-gray-800 text-white sticky top-0 z-20 shadow-md">
            <tr>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Driver Id</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Driver Name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">number</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">driving Liscence</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">restaurant name</th>
              <th className="px-2 md:px-5 py-2 md:py-3 text-[10px] md:text-sm font-semibold tracking-wide text-center">Approve</th>
            </tr>
          </thead>
          <tbody>
        {
          filteredData.map((data,index)=>(
            <tr key={index} className="border-b border-gray-300 hover:bg-gray-50 transition">
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.id}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.name}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">{data.number}</td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">
                <a  href={data.drivingLiscence} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-blue-500 underline cursor-pointer"
                >
                  view
                </a>
              </td>
              <td 
                className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-blue-600 hover:text-blue-900 hover:underline cursor-pointer" 
                onClick={()=>{navigate(`/restaurant/${data.restaurantid}`)}}
              >
                {data.restaurantname===null?"Not yet added":data.restaurantname}
              </td>
              <td className="px-2 md:px-5 py-2 text-[10px] md:text-sm text-center text-gray-800">
                <button 
                  className="bg-blue-500 hover:bg-blue-600 transition text-white rounded px-3 py-1 font-medium" 
                  onClick={()=>{approveRestaurant(data.id)}}
                >
                  Approve
                </button>
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>
    </div>
  </div>
  )
}

export default Index
